import { useEffect, useState } from 'react';
import { ICON_COLOR, IconButton } from '@zep-us/zus';
import { XIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useLocale } from '@/hooks/useLocale';
import { cn } from '@/utils';
import { WorksheetGradientIcon } from './WorksheetGradientIcon';
const STORAGE_KEY = 'quiz_worksheet_promo_dismissed';
const setDismissed = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // ignore storage errors (private mode, etc.)
  }
};
const getDismissed = () => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
interface WorksheetPromoCardProps {
  onClick: () => void;
  className?: string;
}
export const WorksheetPromoCard = ({
  onClick,
  className
}: WorksheetPromoCardProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    locale
  } = useLocale();
  const previewSrc = locale === 'ko' ? '/assets/worksheet_preview_kr.webp' : locale === 'ja' ? '/assets/worksheet_preview_jp.webp' : '/assets/worksheet_preview_en.webp';
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(!getDismissed());
  }, []);
  if (!visible) return null;
  const handleCardClick = () => {
    logger.track('quiz_worksheet_promo_card_click');
    setDismissed();
    setVisible(false);
    onClick();
  };
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDismissed();
    setVisible(false);
  };
  return <div role="button" tabIndex={0} onClick={handleCardClick} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleCardClick();
    }
  }} className={cn('group flex w-full cursor-pointer flex-col overflow-hidden rounded-md border border-opacity-assistive bg-neutral', className)} data-sentry-component="WorksheetPromoCard" data-sentry-source-file="WorksheetPromoCard.tsx">
      <div className="flex flex-col gap-xs px-md py-sm">
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-3xs text-body-sm-bold text-neutral">
            <WorksheetGradientIcon size="xs" data-sentry-element="WorksheetGradientIcon" data-sentry-source-file="WorksheetPromoCard.tsx" />
            {t('common:quizWorksheet.shortLabel')}
          </span>
          <IconButton variant="transparent" intent="neutral" size="xs" onClick={handleClose} data-sentry-element="IconButton" data-sentry-source-file="WorksheetPromoCard.tsx">
            <XIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="XIcon" data-sentry-source-file="WorksheetPromoCard.tsx" />
          </IconButton>
        </div>
        <p className="text-left text-body-sm-medium text-neutral">
          {t('common:quizWorksheet.promo.description')}
        </p>
      </div>
      <img src={previewSrc} className="relative top-[6px] h-[129px]" />
    </div>;
};